import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { IPageHeader } from '../../../../Components/pageheader/pageHeader.model';
import { PageheaderComponent } from '../../../../Components/pageheader/pageheader.component';
import {
  TranslateModule,
  TranslateService,
  TranslatePipe,
} from '@ngx-translate/core';
import { ABOUT_DATA } from '../about.data';
import { CommonModule } from '@angular/common';
import { ArticlesViewComponent } from '../../../../Components/articles-view/articles-view.component';
import { BaseComponent } from '../../../base.component';
import { IPopup } from '../../../../Components/popup/popup.model';
import { ContactCardComponent } from '../../../../Components/contact-card/contact-card.component';
import { AutoUnsubscribe } from '../../../../Services/autoUnsubscribe.service';
import { SchoolApiService } from '../../../../Services/schoolApi.service';
import {
  DOMAIN_TYPE,
  NATIONAL_PAGES,
  SCHEMA_TYPE,
} from '../../../../constants';
import { IList } from '../../../../Models/list.model';
import { IResponse } from '../../../../Models/response.model';
import { ISchoolArticle } from '../../../../Models/schoolArticle.model';
import { Utils } from '../../../../utils';

@AutoUnsubscribe()
@Component({
  selector: 'app-staff',
  standalone: true,
  imports: [
    PageheaderComponent,
    TranslateModule,
    CommonModule,
    ArticlesViewComponent,
    ContactCardComponent,
  ],
  providers: [TranslateService, TranslatePipe, SchoolApiService],
  templateUrl: './staff.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StaffComponent extends BaseComponent {
  public pageOptions: IPageHeader = {
    mainPage: { title: 'about_us', path: '/about' },
    children: [{ title: 'staff', path: null }],
  };

  public STAFF_DATA = ABOUT_DATA.staff;
  public STAFF_DETAILS: any;

  public staffStart: number = 1;
  public staffLimit: number = 2;
  public staffTotalcount: number;

  public formationArticles: IPopup[] = [];
  public formationStart: number = 1;
  public formationLimit: number = 10;
  public formationTotalcount: number;

  constructor(
    override readonly schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef
  ) {
    super(schoolApiService);
    this.domainType = DOMAIN_TYPE.NATIONAL;
  }

  ngOnInit(): void {
    this.onStaffPaginateEvent(0);
    this.onFormationPaginateEvent(0);
  }

  onStaffPaginateEvent($event: number) {
    this.schemaType = SCHEMA_TYPE.MEDIA;
    this.articleType = NATIONAL_PAGES.ABOUT.PERSONAL.STAFF;
    this.staffStart = $event;
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: this.staffStart,
        limit: this.staffLimit,
        sortOrder: 1,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.staffTotalcount = data.payload?.count || 0;
          this.STAFF_DETAILS = data.payload?.list.map((staff) => {
            return {
              image: Utils.mapBase64Image(staff.attachments[0].content),
              name: staff.title[this.language],
              job: staff.description[this.language],
            };
          });
          this.cdr.detectChanges();
        }
      });
  }

  onFormationPaginateEvent($event: number) {
    this.formationStart = $event;
    this.schemaType = SCHEMA_TYPE.ARTICLE;
    this.articleType = NATIONAL_PAGES.ABOUT.PERSONAL.FORMATION;
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: this.formationStart,
        limit: this.formationLimit,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.formationTotalcount = data.payload?.count || 0;
          this.formationArticles = this.mapArticles(data.payload?.list || []);
          this.cdr.detectChanges();
        }
      });
  }
}
